import React from 'react'

import Button from '@react/react-spectrum/Button'
import Wait from '@react/react-spectrum/Wait'

export function Tile({ name, text, active, loading, error, buttons, children }) {
  return (
    <div className={`Tile Tile--${name?.replaceAll(' ', '')} ${active ? 'Tile--active' : ''}`}>
      {name && <p>{name}</p>}
      {loading && <Wait />}

      {!loading && text && <h2>{text}</h2>}
      {error && (
        <p>
          {error
            ? 'The property does not exist in Data Collection, please assign another property or create a new one.'
            : error}
        </p>
      )}
      <div>
        {Array.isArray(buttons) && buttons?.map((btn, idx) => <Button key={idx} {...btn}></Button>)}
        {children}
      </div>
    </div>
  )
}

export function DataCollectionTile({ text, url, loading, error }) {
  const isSet = !!text
  const buttons = [{ label: 'View', disabled: !(isSet && url && !error), onClick: () => window.open(url) }]

  return <Tile name='Data Collection' text={text} active={isSet} error={error} loading={loading} buttons={buttons} />
}

export function AepTile({ aep }) {
  const sandbox = aep?.sandbox
  const tenant = aep?.imsOrg?.tenantID
  const url = sandbox && tenant && `https://experience.adobe.com/#/@${tenant}/sname:${sandbox}/platform/home`

  const isSet = !!sandbox
  const buttons = [{ label: 'View', disabled: !(isSet && url), onClick: () => window.open(url) }]

  return <Tile name='AEP' text={sandbox} active={isSet} buttons={buttons} />
}
export function TargetTile({ target, tenantId }) {
  const isSet = tenantId && target?.enabled
  const url = `https://experience.adobe.com/#/@${tenantId}/target/activities`

  const buttons = [{ label: 'View', onClick: () => window.open(url) }]

  return <Tile name='Target' text={isSet ? '@' + tenantId : null} active={isSet} buttons={buttons} />
}

export { ChatBotTile } from './ChatBotTile'
